<template>
	<Modal @close="$emit('close')">
		<div class="content">
			<div class="warningTitle caption">
				<img class="icon" src="~@/assets/icons/icon-location-pin.svg" />{{ $t('noCoverage') }}
			</div>
			<div class="caption">
				{{ $t('currentDeliveries') }}
			</div>
			<div class="caption" style="font-weight:bolder; color:black;">
				{{ $t('telephonicAttention') }} <span style="color: #646979; font-weight:400;">{{phone}}</span>
			</div>
		</div>
	</Modal>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import Modal from '@/components/Modal.vue'

@Component({
	components: {
		Modal
	}
})
export default class NoCoverageModal extends Vue {
	phone = this.$store.state.deliveryMenu.phones.localPhone.phone
}
</script>
<style>
.content {
	font-size: 16px;
	font-weight: 500;
	color: #646979;
	font-stretch: condensed;
}

.caption {
	display: block;
	padding: 10px;
}

.warningTitle {
	color: #eb5757;
	font-size: 18px;
	text-align: center;
	font-weight: 700;
}

.icon {
	margin-bottom: -1%;
	padding-right: 4px;
	width: 18px;}
</style>
